import { useTranslation } from "next-i18next";
import React, { useState, useEffect } from "react";

import { useCurrentLocale } from "@/context/LanguageContext";

import AfterpayMark from "../../assets/icons/afterpay-mark.svg";
import { NUM_INSTALLMENTS } from "../../shared/constants";
import { generatePriceFromLocale, convertPriceToNumber } from "../../utils/strings";
import AfterpayModal from "../modals/afterpay-modal/afterpay-modal";
import styles from "./learn-more.module.scss";

interface Props {
    price: string;
}

const LearnMore: React.FC<Props> = ({ price }) => {
    const [showModal, setShowModal] = useState(false);
    const toggleShowModal = () => {
        setShowModal(!showModal);
    };
    const locale = useCurrentLocale();
    const { t } = useTranslation();
    const [installmentPrice, setInstallmentPrice] = useState<number>(0);

    useEffect(() => {
        const amount = convertPriceToNumber(price);
        if (!amount) return;
        setInstallmentPrice(amount / NUM_INSTALLMENTS);
    }, [price]);

    return (
        <>
            <div className={styles.learnMoreContainer}>
                <div className={styles.afterpayMark}>
                    <AfterpayMark />
                </div>
                <div className={styles.contentContainer}>
                    <span>
                        {t("giftCards.learnMore.installments")}
                        &nbsp;
                        <strong>{generatePriceFromLocale(installmentPrice, locale)}</strong>
                        &nbsp;
                        {t("giftCards.learnMore.with")}
                        &nbsp;
                        <strong>{t("giftCards.learnMore.brand")}</strong>
                    </span>
                    <span className={styles.moreInfo} onClick={toggleShowModal}>
                        <strong>{t("giftCards.learnMore.moreInfo")}</strong>
                    </span>
                </div>
            </div>
            {showModal && <AfterpayModal onClick={toggleShowModal} />}
        </>
    );
};

export default LearnMore;
